module.exports = __webpack_public_path__ + "img/rectangle.989b238f.svg";